import TEnvReader from '../readers/Env';

var getSelectedDealerIdFromLS = function getSelectedDealerIdFromLS() {
  var userInfo = TEnvReader.userInfo();
  var dealerId = userInfo.dealerId;
  return dealerId;
};

export default getSelectedDealerIdFromLS;